import { RtErpcOrigin } from '@bds/railtrac-models';
import ODataStore from 'devextreme/data/odata/store';

export class BdsErpcOriginGridDialogModel {
    isNew: boolean;
    origin: RtErpcOrigin;
    originId?: number;
    splcStore: ODataStore;
}
